import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CourseSubjectType } from "../../../types/CourseSubject";

const initialState: CourseSubjectType = {
    id: "",
    status: false,
    idCourse: "",
    idSubject: "",
    semester: 0,
    isCore: false,
    hasExam: false,
    level: 0,
};
export const courseSubjectSlice = createSlice({
    name: "courseSubjectForm",
    initialState,
    reducers: {
        setUpdateCourseSubjectData: (
            state, action: PayloadAction<CourseSubjectType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateCourseSubjectData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateCourseSubjectData, resetUpdateCourseSubjectData } = courseSubjectSlice.actions;
export default courseSubjectSlice.reducer;